import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiTab = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: '28px',
      minWidth: 'auto',
      padding: '6px 12px',
      border: '1px solid transparent',
      borderRadius: '8px',
      color: 'var(--mui-palette-text-secondary)',
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      '&:hover': {
        color: 'var(--mui-palette-text-primary)',
        backgroundColor: 'var(--mui-palette-background-level1)',
      },
      '&.Mui-selected': {
        color: 'var(--mui-palette-text-primary)',
        backgroundColor: 'var(--mui-palette-background-paper)',
        borderColor: 'var(--mui-palette-divider)',
        boxShadow: theme.shadows[1],
      },
      '&:focus-visible': {
        outline: 'none',
        boxShadow: `0 0 0 3px rgba(${theme.vars.palette.primary.mainChannel} / 0.18)`,
      },
    }),
  },
} satisfies Components<Theme>['MuiTab'];
